"use client";

import { Text } from "@/components/ui/text";
import { Switch } from "@/components/ui/switch";
import { ArtDirection } from "@/components/util/art-direction";

import { useSwitchImage, UseSwitchImageProps } from "./use-switch-image";

export type SwitchImageProps = UseSwitchImageProps;

function SwitchImage(props: SwitchImageProps) {
  const {
    className,
    styles,
    data: { title, description, label, image },
    checked,
    onChange,
    sectionName,
  } = useSwitchImage(props);

  return (
    <section className={styles.base({ className })} data-section-name={sectionName}>
      <header className={styles.header()}>
        {title && (
          <Text tag="h4" size="titleMedium" className={styles.title()}>
            {title}
          </Text>
        )}
        {description && (
          <Text tag="p" size="bodyMedium" className={styles.description()}>
            {description}
          </Text>
        )}
      </header>

      <div className={styles.content()}>
        <ArtDirection
          desktop={image}
          containerClassName={styles.mediaWrapper()}
          className={styles.media()}
        />
        <Switch label={label} defaultChecked={checked} onCheckedChange={onChange} />
      </div>
    </section>
  );
}

export default SwitchImage;
